import module from "../module";
import template from "./pdf-viewer-embedded.tmpl.html";

module.component("ppmPdfViewerEmbedded", {
  bindings: {
    documentId: "<",
    version: "<"
  },
  controller,
  template
});

function controller(ApiPdfService, $element) {
  "ngInject";
  const vm = this;

  vm.$onChanges = function() {
    if (vm.version == null) {
      return;
    }

    ApiPdfService.getEmbedDocumentUrl({
      documentId: vm.documentId,
      version: vm.version
    }).then(url => {
      const area = $element[0].querySelector(".document-area");

      while (area.firstChild) {
        area.removeChild(area.firstChild);
      }

      const objectElement = document.createElement('object');

      vm.trustedUrl = url; // it is already trusted from the method that got the url.
      objectElement.setAttribute('data', vm.trustedUrl);
      objectElement.setAttribute('type', 'application/pdf');

      area.appendChild(objectElement);
    });
  };
}
